import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../config/apiconfig';
import { Clock, Mail } from 'lucide-react';

export default function WaitingApproval() {
  const { user } = useAuth();
  const [status, setStatus] = useState('pending');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        if (!user?.id) return;
        const res = await fetch(`${API_BASE_URL}/api/recruiter/profile/${user.id}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setStatus(data?.approval_status || 'pending');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [user?.id]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 container mx-auto p-6">
        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow p-8 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-indigo-50 flex items-center justify-center mb-4">
            <Clock className="w-8 h-8 text-indigo-600" />
          </div>
          <h1 className="text-2xl font-semibold mb-2">Waiting for Admin Approval</h1>
          {loading ? (
            <p className="text-gray-600">Checking your approval status...</p>
          ) : status === 'rejected' ? (
            <>
              <p className="text-gray-700">Your account request has been <span className="font-medium text-red-600">rejected</span> by an admin.</p>
              <p className="text-gray-600 mt-2">If you believe this is a mistake, please contact your company admin.</p>
            </>
          ) : (
            <>
              <p className="text-gray-700">Your recruiter account is currently <span className="font-medium text-indigo-600">pending approval</span>.</p>
              <p className="text-gray-600 mt-2">You will receive an email once your access is approved.</p>
              <div className="mt-4 inline-flex items-center gap-2 text-gray-700 bg-gray-50 border border-gray-200 rounded px-3 py-1.5">
                <Mail className="w-4 h-4" />
                <span>{user?.email}</span>
              </div>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
